function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.99981 18.5564L13.778 26.3345L26.7416 8.18545",
  fill: "none",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const Svg31Px = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: 33,
  height: 33,
  viewBox: "0 0 33 33",
  fill: "none",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);
const ForwardRef = React.forwardRef((props, ref) => React.createElement(Svg31Px, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/31px.92bbdc0b.svg";
export { ForwardRef as ReactComponent };